var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper features" },
    [
      _vm.showModal
        ? _c(
            "Modal",
            {
              attrs: {
                "show-footer": "",
                "ok-text": _vm.$t("settings.create"),
                title: _vm.$t("settings.newVisitorProfileInformation"),
                description: _vm.$t(
                  "settings.newVisitorProfileInformationDescription"
                ),
              },
              on: {
                cancel: function ($event) {
                  _vm.showModal = false
                },
                ok: function ($event) {
                  return _vm.createVisitorAttribute()
                },
              },
            },
            [
              _c("VisitorAttributesForm", {
                on: {
                  input: function (data) {
                    return (_vm.form = data)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("div", [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("settings.visitorAttribute"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("settings.visitorLoginFormSubtitles"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "add-attribute",
              attrs: { type: "primary", ghost: "" },
              on: {
                click: function ($event) {
                  _vm.showModal = true
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("settings.newAdd")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "fields" }, [
          _c(
            "div",
            { staticClass: "form" },
            [
              _c("VisitorAttributes", {
                model: {
                  value: _vm.visitorAttributes,
                  callback: function ($$v) {
                    _vm.visitorAttributes = $$v
                  },
                  expression: "visitorAttributes",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }